import { useCart } from "@/hooks/useCart";
import { NaviDocs } from "@/interfaces/navi.interface";
import { Checkbox, ListItem, ListItemText } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import FindInPageIcon from "@material-ui/icons/FindInPage";
import moment from "moment";
import { useRouter } from "next/router";
import React from "react";
import styles from "./styles.module.less";

interface IProps {
  paper: NaviDocs;
  index: number;
  ids: string[];
  handleToggle: (id: string) => void;
}

const ItemList: React.FC<IProps> = ({ paper, index, ids, handleToggle }) => {
  const { handleRemove } = useCart();

  const router = useRouter();

  const handleRoute = (id: string) => {
    router.push("/navigator/paper/[id]", `/navigator/paper/${id}`);
  };

  return (
    <ListItem
      key={paper?.id}
      dense
      button
      onClick={() => handleToggle(paper?.id)}
    >
      <ListItemIcon>
        <Checkbox
          edge="start"
          checked={ids.includes(paper?.id)}
          tabIndex={-1}
          disableRipple
          color="primary"
        />
      </ListItemIcon>
      <ListItemText
        primary={
          <span className={styles.title}>
            {index + 1}. {paper?.paperContents?.content?.articleTitle}
          </span>
        }
        secondary={
          <p className={styles.second}>
            <span className={styles.span}>
              {paper?.paperContents?.content?.medlineJournalInfo?.medlineTA}
            </span>
            <span className={styles.span}>
              {moment(
                paper?.paperContents?.content?.journalInfo?.pubdate
              ).fromNow()}
            </span>
            <span className={styles.span}>
              {paper?.paperContents?.journal?.nImpactFactor}
            </span>
          </p>
        }
      />
      <ListItemSecondaryAction>
        <IconButton edge="end" onClick={() => handleRemove(paper?.id)}>
          <DeleteOutlineIcon />
        </IconButton>
        <IconButton edge="end" onClick={() => handleRoute(paper?.id)}>
          <FindInPageIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default ItemList;
